const numberFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

// export const formatNumber = (value) => {
//   if (typeof value !== "number" ) {
//     value = parseFloat(value);
//   }
//   if (isNaN(value)) {
//     return "-";
//   }
//   return numberFormatter.format(value);
// };

export const formatNumber = (value, defaultDisplay = '-') => {
  if (value === null || value === undefined || value === '') {
    return defaultDisplay;
  }

  const number = typeof value === 'number' ? value : parseFloat(value);

  if (isNaN(number)) {
    return defaultDisplay;
  }

  return numberFormatter.format(number);
};

// export const formatNumberUS = (value) => {
//   const parsed = parseFloat(value);
//   if (isNaN(parsed)) {
//     console.warn("formatNumber: value invalid", value);
//     return "-";
//   }
//   return new Intl.NumberFormat("en-US", {
//     style: "decimal",
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2,
//   }).format(parsed);
// };

export const formatNumberUS = value => {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return '-';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(parsed);
};
